<template>
  <div class="news" v-loading="loading">
    <div class="news_content"  >
      <div v-if="newsList.length>0">
        <ul>
          <li v-for="(item,index) in newsList"  :key="index" @click="newsDetails(item)" >
            <span><span class="news_content_bar" :class="item.top?'top':(item.type==1?'news_content_bar_blue':'news_content_bar_pink')">
              {{item.top?'置顶':(item.type)}}</span><span class="news_content_title">{{ item.title }}</span></span>
            <em>[{{item.publishTime}}]</em>
          </li>
        </ul>
      </div>
      <div v-else class="nodata">
        暂无数据
      </div>
    </div>
  </div>
</template>
<script>

import {getNewsNotice} from '@/api/home'
import {getNewsNoticeDetail} from '@/api/politicalPost'
export default {
  props:{
    type:{
      type:Number
    },
    id:{
      type:Number
    },
  },
  components: {
    
  },
  data() {
    return {
      loading:false,
      newsList:[],
      page:{
        page:1,
        pageSize:5,
        module:''
      },
      myBackToTopStyle: {
        'right': '100px',
        'bottom': '150px',
        'width': '40px',
        'height': '40px',
        'border-radius': '20px',
        'line-height': '40px', 
        'background': '#fff'
      },
    };
  },
  methods: {
    newsDetails(item){
      // console.log(this.type)
      this.$router.push({name:'newsDetails',query:{data:JSON.stringify(item),type:this.type?this.type:this.$route.path}})
    },
    setNewsData(page){//获取新闻数据
      this.loading = true
      this.newsList.length=0
      getNewsNotice(page).then(res=>{
        console.log(res.result)
        if(res.code==200 && res.result){
          let data=res.result
          this.newsList=data.records
        } else {
          this.newsList=[]
        }
        this.loading = false
      })
    },
    // 指导员新闻
    async getNewsNoticeDetail(id){
      this.loading = true
      this.newsList.length=0
      let res=await getNewsNoticeDetail({id:id})
      if(res.code==200 && res.result){
        res.result.rows.forEach((item,index) => {
          if(index<=3){
            this.newsList.push(item)
          }
        });
      } else {
        this.newsList=[]
      }
      this.loading = false
    }
  },
  mounted(){
  },
  created() {
    let val=this.$route.path
    let page={page:1,pageSize:6}
    if(val =='/home'){
      this.setNewsData(page)
    } else if(val =='/schoolSite'){
      page.module=1
      page.type='公告'
      this.setNewsData(page)
    } else if(val =='/wisdomGym'){
      page.module=2
      page.type='公告'
      this.setNewsData(page)
    } else if(val =='/politicalPost'){
      page.module=4
      // this.setNewsData(page)
    } else if(val =='/freeVenue'){
      page.module=3
      page.type='公告'
      this.setNewsData(page)
    }

    
    
  },
  activated(){
    // console.log(1,this.type)
    let page={page:1,pageSize:6}
    if(this.type==0){
      page.module=1
      page.type='公告'
      this.setNewsData(page)
    } else if(this.type==1){
      page.module=2
      page.type='公告'
      this.setNewsData(page)
    } else if(this.type==3){
      page.module=3
      page.type='公告'
      this.setNewsData(page)
    } else if(this.type==2){
      page.module=4
      this.setNewsData(page)
    } 
  },
  computed: {},
  beforeDestroy() {},
  watch:{
    
  }
};
</script>
<style  lang="less" >
.news_content {
  min-height: 300px;
  ul {
    padding: 0;
    list-style: none;

    li {
      cursor: pointer;
      height: 55px;
      line-height: 55px;
      border-bottom: 1px dashed #e5e5e5;
      color: #666666;
      font-size: 16px;

      .news_content_title:hover{
        color: #2F89EB;
      }

      >span{
        display: inline-block;
        width: 300px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;

        .news_content_bar{
          display: inline-block;
          border-radius: 8px;
          padding: 4px 11px;
          font-size: 14px;
          line-height: 20px;
          margin-right: 15px;
        }

        .news_content_bar_blue{
          color: #2F89EB;
          border: 1px solid #2F89EB;
        }

        .news_content_bar_pink{
          color: #FF6767;
          border: 1px solid #FF6767;
        }

        .top{
          background: #FF6767;
          color: #fff;
        } 

      }
      em {
        float: right;
        font-style: normal;
        color: #999;
        font-size: 14px;
      }
    }
  }
}
.nodata{
  font-size: 16px;
  color: #666;
  text-align: center;
  line-height: 150px;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue